export default {
  export: 'Export',
  cancel: 'Cancel',
  back: 'Back',
  try: 'Try Again',
  download_success: 'Download successful',
  download_failed: 'Download failed',
  downloading: 'Downloading',

  modal_warning: {
    title: 'Confirm',
    desc: 'Expire Data has expired. Need to download again.',
    cancel: 'Cancel',
  },
};
